<div class="reports-shell">
	<div class="toolbar">
		<div class="legend">
			<details class="legend-details">
				<summary class="legend-summary">
					<div class="legend-summary-left">
						<i class="pi pi-info-circle"></i>
						<span class="legend-summary-title">Risk thresholds</span>
						<span class="legend-summary-inline">
							High ≥ {{ thresholds.highMinDays }}d •
							Medium {{ thresholds.mediumMinDays }}–{{ thresholds.mediumHintMaxDays }}d •
							Low &lt; {{ thresholds.lowMaxDays }}d
						</span>
					</div>

					<i class="pi pi-chevron-down legend-chevron"></i>
				</summary>

				<div class="legend-body">
					<span class="legend-item">
						<span class="pill risk-high">High</span>
						<span class="legend-text">
							By Report High Risk: ≥ {{ thresholds.highMinDays }} days
						</span>
					</span>

					<span class="legend-item">
						<span class="pill risk-medium">Medium</span>
						<span class="legend-text">
							By Report Medium Risk: Between {{ thresholds.mediumMinDays }} and
							{{ thresholds.mediumHintMaxDays }} days
						</span>
					</span>

					<span class="legend-item">
						<span class="pill risk-low">Low</span>
						<span class="legend-text">
							By Report Low Risk: &lt; {{ thresholds.lowMaxDays }} days
						</span>
					</span>
				</div>
			</details>
		</div>

		<div class="sort">
			<label class="sort-label">Sort</label>
			<p-dropdown
				[options]="sortOptions"
				[(ngModel)]="sortOrder"
				(onChange)="onSortChange()"
				placeholder="Sort"
				styleClass="sort-dd"
			></p-dropdown>
		</div>
	</div>

	<div *ngIf="(errorStatus$ | async) !== null as err" class="error-card">
		Error loading reports ({{ err }}).
	</div>

	<!-- Loading skeleton -->
	<div *ngIf="(loading$ | async) === true" class="list">
		<div class="row skeleton" *ngFor="let i of [1,2,3,4,5]">
			<div class="left">
				<p-skeleton width="70%" height="1.2rem"></p-skeleton>
				<p-skeleton width="40%" height="0.9rem" styleClass="mt-2"></p-skeleton>
			</div>
			<div class="right">
				<p-skeleton width="3.5rem" height="1.4rem"></p-skeleton>
				<p-skeleton width="2.8rem" height="0.9rem" styleClass="mt-2"></p-skeleton>
			</div>
		</div>
	</div>

	<!-- List -->
	<ng-container *ngIf="(loading$ | async) === false">
		<ng-container *ngIf="vm$ | async as vm">
			<div *ngIf="vm.totalRecords === 0" class="empty">
				No reports found for the selected filters.
			</div>

			<ng-container *ngIf="breakdownByName$ | async as breakdown">
				<div class="list" *ngIf="vm.totalRecords > 0">
					<div class="row-wrap" *ngFor="let r of vm.rows; trackBy: trackByName">

						<!-- Main row -->
						<div class="row">
							<div class="left">
								<div class="title-line">
									<div class="name">{{ r.name }}</div>
									<span class="pill" [ngClass]="riskClass(r.risk)">{{ r.risk }}</span>
									<span class="pill ai" *ngIf="r.isAiEnabled">AI</span>
								</div>

								<div class="meta">
									{{ r.propertyCount }} properties • {{ r.completed }}/{{ r.totalTasks }} completed
								</div>
							</div>

							<div class="right">
								<div class="value" [ngClass]="valueClass(r.risk)">
									{{ r.avgDaysToComplete | number : '1.0-2' }}
								</div>
								<div class="unit">Av. Days</div>
							</div>

							<!-- Chevron toggle (match High Risk Hotels) -->
							<button
								pButton
								type="button"
								class="p-button-text chevron-toggle"
								[icon]="isExpanded(r.name) ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
								(click)="toggleExpand(r.name); $event.stopPropagation()"
								[attr.aria-expanded]="isExpanded(r.name)"
								aria-label="Toggle breakdown"
							></button>
						</div>

						<!-- Drawer (match High Risk Hotels: table-based) -->
						<div class="drawer" *ngIf="isExpanded(r.name)">
							<div class="drawer-title">Per-property breakdown</div>

							<div *ngIf="(breakdown[r.name]?.length ?? 0) > 0; else noBreakdown">
								<table class="drawer-table">
									<thead>
									<tr>
										<th>Property</th>
										<th class="drawer-amount">Completed</th>
										<th class="drawer-amount">Av. Days</th>
										<th class="drawer-amount">Risk</th>
									</tr>
									</thead>

									<tbody>
									<tr
										*ngFor="let p of (breakdown[r.name] ?? [])"
										[class.is-zero]="(p.completed ?? 0) === 0"
									>
										<td class="report-name" title="{{ p.propertyName }}">
											{{ p.propertyName }}
										</td>

										<td class="drawer-amount">
											{{ p.completed }}/{{ p.totalTasks }}
											<span class="muted" *ngIf="(p.totalTasks ?? 0) > 0">
												({{ p.completionRate | number:'1.0-0' }}%)
											</span>
										</td>

										<td class="drawer-amount">
											<ng-container *ngIf="p.avgDaysToComplete !== null; else noDays">
												{{ p.avgDaysToComplete | number:'1.0-2' }}
											</ng-container>
											<ng-template #noDays>--</ng-template>
										</td>

										<td class="drawer-amount">
											<ng-container *ngIf="p.risk !== null; else noRisk">
												<span class="pill" [ngClass]="riskClass(p.risk)">{{ p.risk }}</span>
											</ng-container>
											<ng-template #noRisk>
												<span class="pill pill-na">--</span>
											</ng-template>
										</td>
									</tr>
									</tbody>
								</table>
							</div>

							<ng-template #noBreakdown>
								<div class="drawer-empty">No properties found for this report.</div>
							</ng-template>
						</div>

					</div>

					<p-paginator
						[rows]="rowsPerPage"
						[totalRecords]="vm.totalRecords"
						[first]="vm.first"
						(onPageChange)="onPageChange($event)"
						styleClass="paginator"
					></p-paginator>
				</div>
			</ng-container>
		</ng-container>
	</ng-container>
</div>
